// @ts-nocheck

import { Box, Button, Link, Paper, Typography } from '@material-ui/core'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { ArrowLeft, Check } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import ExcelLogo from '../../../../assets/images/learnstage-logo.png'
import noDataImage from '../../../../assets/images/no-program.svg'
import SchoolStoreAddOn from '../../../../components/sis/student/allEnrollments/programDetails/SchoolStoreAddOn'
import { ROUTES } from '../../../../helpers/constants'
import { ADDITIONAL_FEE_TYPES } from '../../../../helpers/constants'
import { calculateSum, getSchoolUrl, noop } from '../../../../helpers/utils'
import PersonalInforFormPopup from './PersonalInfoFormPopup'
function SchoolStores({
  schoolStores,
  paymentGateways,
  selectedGateway,
  setSelectedGateway,
  onGatewaySelect,
  wallet,
  getPaymentGateways,
  selectedStores,
  setSelectedStores,
  masterData,
  user,
  states,
  searchStates,
  schooolCountries,
  createGuestCheckout,
  setFormData,
  togglePersonalInfoForm,
  personalInforForm,
  openPaymentPopup,
  togglePaymentPopup,
  metadata,
  setOpenPaymentPopup,
  school,
}) {
  const { t } = useTranslation()
  const history = useHistory()
  const params = useParams()
  const [showMore, setShowMore] = React.useState<string[]>([])
  const [totalAmount, setTotalAmount] = useState()
  const [selectedStoresList, setSelectedStoresList] = React.useState([])
  const closePaymentPopup = () => {
    setOpenPaymentPopup(false)
    setSelectedGateway()
  }

  const checkout = () => {
    const selectedFee = schoolStores.filter((item) =>
      selectedStores.includes(item.afc_id.toString())
    )
    const payableAmount = calculateSum(selectedFee, 'afc_amount')
    setTotalAmount(payableAmount)
    getPaymentGateways(payableAmount)
    togglePersonalInfoForm()
    setSelectedStoresList(selectedFee)
  }

  const onCheck = (event) => {
    if (Array.isArray(event)) {
      return setSelectedStores(event.map((item) => item))
    }
    const id = event.currentTarget.attributes['data-id'].value
    if (selectedStores.includes(id)) {
      setSelectedStores(selectedStores.filter((item) => item !== id))
    } else {
      setSelectedStores((oldState) => [...oldState, id])
    }
  }

  const reset = () => {
    setSelectedStores([])
  }

  const moreTextHandler = (id) => {
    if (showMore.includes(id)) {
      const tempShowMore = showMore.filter((showId) => showId !== id)
      setShowMore(tempShowMore)
    } else {
      setShowMore([...showMore, id])
    }
  }

  return (
    <>
      <Box
        pb={2}
        px={3}
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        flexDirection="column"
      >
        <Box
          width="100%"
          flexGrow={0}
          display="flex"
          alignItems="center"
          justifyContent={{ xs: 'center', md: 'space-between' }}
          flexDirection="row"
          px={0}
          py={2}
          className="allProgmResvi-between"
        >
          <Box className="brand-logo">
            <img
              src={school.sch_logo || ExcelLogo}
              alt="Logo"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = ExcelLogo
              }}
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexDirection="row"
            fontWeight="fontWeightMedium"
            fontSize="14px"
          >
            <Button
              className="custom-default-button text-transform-none"
              // size="large"
              variant="contained"
              disableElevation
              startIcon={<ArrowLeft width={16} height={16} />}
              onClick={() => {
                history.push(getSchoolUrl({ ...params, to: `${ROUTES.LOGIN}` }))
              }}
              replaceHistory={true}
            >
              {t('back')}
            </Button>
          </Box>
        </Box>
        <Typography component="h4" align="left" variant="h5" color="textPrimary" tabIndex={0}>
          <Box component="span" fontWeight="700">
            {t('schoolStores')}
          </Box>
        </Typography>
      </Box>

      <Box px={3}>
        <Paper rounded="true" elevation={1} className="paper-round">
          <Box p={{ xs: 0, sm: 3 }}>
            <>
              {schoolStores
                ?.filter(
                  (items) => items.afc_fee_payable_type !== ADDITIONAL_FEE_TYPES.EXTENSION_FEE
                )
                ?.map((row) => {
                  return (
                    <Box
                      className={clsx('program-list  announcement-list custom-accordion', {
                        selected: selectedStores?.includes(row.afc_id.toString()),
                      })}
                      py={2}
                      px={2}
                      display="flex"
                      alignItems={{ xs: 'flex-start', sm: 'center' }}
                      justifyContent="space-between"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      key={row.afc_id}
                    >
                      <Box component="span" mr={1}>
                        <Typography component="h4" variant="body1" tabIndex={0}>
                          <Box className="text-primary" fontWeight={600}>
                            {row.afc_fee_name}
                          </Box>
                        </Typography>
                        <Typography
                          component="h6"
                          align="left"
                          variant="subtitle2"
                          color="textPrimary"
                        >
                          <Box component="div" fontSize={14} fontWeight={600}>
                            {t('with$', {
                              amount: row?.afc_amount,
                            })}
                          </Box>
                        </Typography>

                        <Typography
                          component="h6"
                          align="left"
                          variant="subtitle2"
                          color="textPrimary"
                        >
                          <Box component="span" fontWeight="fontWeightMedium" fontSize="12px">
                            {showMore.includes(row.afc_id)
                              ? row.afc_description
                              : `${row?.afc_description?.slice(0, 300)}`}
                            {!showMore.includes(row.afc_id)
                              ? row?.afc_description?.length >= '300'
                                ? '...'
                                : ''
                              : ''}
                            {row?.afc_description?.length >= '300' && (
                              <Box component="span" fontWeight="fontWeightBold" ml={1}>
                                <Link
                                  className="text-info cursor-pointer"
                                  component="a"
                                  onClick={() => moreTextHandler(row.afc_id)}
                                  key={row.afc_id}
                                >
                                  {t(showMore.includes(row.afc_id) ? 'lessDetails' : 'moreDetails')}
                                </Link>
                              </Box>
                            )}
                          </Box>
                        </Typography>
                      </Box>

                      <Box component="span" fontSize={16} fontWeight={600} minWidth="112px">
                        {selectedStores.includes(row.afc_id.toString()) ? (
                          <Button
                            className="custom-default-button text-transform-none"
                            variant="contained"
                            disableElevation
                            fullWidth
                            data-id={row.afc_id}
                            onClick={(event) => onCheck(event)}
                            startIcon={<Check width={16} height={16} />}
                          >
                            {t('selected')}
                          </Button>
                        ) : (
                          <Button
                            className="text-transform-none"
                            variant="contained"
                            color="primary"
                            disableElevation
                            fullWidth
                            data-id={row.afc_id}
                            onClick={(event) => onCheck(event)}
                          >
                            {t('select')}
                          </Button>
                        )}
                      </Box>
                    </Box>
                  )
                })}
              {schoolStores.length !== 0 && (
                <Box
                  mt={{ xs: 1, sm: 0 }}
                  display="flex"
                  alignItems="center"
                  justifyContent={{
                    xs: 'flex-end',
                    sm: 'flex-end',
                    md: 'space-between',
                  }}
                >
                  <Button
                    className="custom-default-button text-transform-none"
                    size="large"
                    variant="contained"
                    disableElevation
                    disabled={!selectedStores?.length}
                    onClick={() => reset()}
                  >
                    {t('reset')}
                  </Button>
                  <Button
                    className="text-transform-none"
                    size="large"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => checkout()}
                    disabled={!selectedStores?.length}
                    style={{ minWidth: '128px' }}
                  >
                    {t('checkout')}
                  </Button>
                </Box>
              )}
              {schoolStores.length === 0 ? (
                <Box
                  p={5}
                  dispaly="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                >
                  <Box mb={3} display="flex" justifyContent="center" className="no-data-image">
                    <img width="200px" src={noDataImage} alt="no data" />
                  </Box>
                  <Box
                    component="p"
                    fontSize="22px"
                    fontWeight="600"
                    align="center"
                    className="custom-table-no-data"
                  >
                    {t('noStoresFound')}
                  </Box>
                </Box>
              ) : null}
            </>
          </Box>
        </Paper>
      </Box>
      <SchoolStoreAddOn
        open={openPaymentPopup}
        close={closePaymentPopup}
        paymentGateways={paymentGateways}
        selectedGateway={selectedGateway}
        onGatewaySelect={onGatewaySelect}
        wallet={wallet}
        totalAmount={totalAmount}
        selectedStoresList={selectedStoresList}
        onSchoolAddOn={createGuestCheckout}
        togglePersonalInfoForm={togglePersonalInfoForm}
        togglePaymentPopup={togglePaymentPopup}
      />
      <PersonalInforFormPopup
        open={personalInforForm}
        onClose={togglePersonalInfoForm}
        masterData={masterData}
        studentInfoState={user}
        schooolCountries={schooolCountries}
        searchStates={searchStates}
        states={states}
        togglePaymentPopup={togglePaymentPopup}
        setFormData={setFormData}
        metadata={metadata}
      />
    </>
  )
}
SchoolStores.propTypes = {
  schoolStores: PropTypes.array,
  assignTransactionToggle: PropTypes.func,
  enrollmentDetails: PropTypes.object,
  paymentGateways: PropTypes.array,
  selectedGateway: PropTypes.string,
  setSelectedGateway: PropTypes.func,
  onGatewaySelect: PropTypes.func,
  wallet: PropTypes.object,
  getPaymentGateways: PropTypes.func,
  selectedStores: PropTypes.array,
  setSelectedStores: PropTypes.func,
  masterData: PropTypes.object,
  user: PropTypes.object,
  schooolCountries: PropTypes.array,
  searchStates: PropTypes.func,
  onSchoolAddOn: PropTypes.func,
  createGuestCheckout: PropTypes.func,
  setFormData: PropTypes.func,
  states: PropTypes.array,
  togglePersonalInfoForm: PropTypes.func,
  personalInforForm: PropTypes.bool,
  openPaymentPopup: PropTypes.bool,
  togglePaymentPopup: PropTypes.func,
  metadata: PropTypes.object,
  setOpenPaymentPopup: PropTypes.func,
  school: PropTypes.object,
}

SchoolStores.defaultProps = {
  schoolStores: [],
  assignTransactionToggle: noop,
  enrollmentDetails: {},
  paymentGateways: [],
  selectedGateway: '',
  setSelectedGateway: noop,
  wallet: {},
  getPaymentGateways: noop,
  selectedStores: [],
  setSelectedStores: noop,
  masterData: {},
  user: {},
  schooolCountries: [],
  searchStates: noop,
  onSchoolAddOn: noop,
  createGuestCheckout: noop,
  setFormData: noop,
  states: [],
  togglePersonalInfoForm: noop,
  personalInforForm: false,
  openPaymentPopup: false,
  togglePaymentPopup: noop,
  metadata: {},
  setOpenPaymentPopup: noop,
  school: {},
}

export default SchoolStores
